var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "stock-source-pane" },
    [
      _vm.isActivated
        ? _c("ExternalContentView", {
            ref: "content",
            attrs: {
              endpoint: _vm.endpoint,
              "page-size": _vm.pageSize,
              "extra-params": _vm.params,
              "show-search": false,
              "external-preview": true,
            },
            on: {
              onSelectedItems: _vm.onSelectedItems,
              "open-preview": (item) => _vm.$emit("open-preview", item),
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }